import React, { ReactNode } from "react";
import clsx from "clsx";

type Position =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "center-left"
  | "center-right";

type Theme =
  | "blue"
  | "yellow"
  | "purple"
  | "orange"
  | "outline"
  | "green"
  | "primary";

interface StatCardProps {
  value: string;
  label: string;
  position?: Position;
  theme?: Theme;
  icon?: ReactNode;
}

const positionClasses: Record<Position, string> = {
  "top-left": "absolute top-10 -left-10",
  "top-right": "absolute top-10 -right-10",
  "bottom-left": "absolute -bottom-6 -left-6",
  "bottom-right": "absolute -bottom-6 -right-6",
  "center-left": "absolute top-1/2 -left-14 -translate-y-1/2",
  "center-right": "absolute top-1/2 -right-14 -translate-y-1/2",
};

const themeClasses: Record<Theme, string> = {
  blue: "text-primary-500",
  yellow: "text-secondary-500 text-black",
  purple: "text-purple-600 text-white",
  orange: "text-orange-500 text-white",
  green: "text-success-500 text-white",
  primary: "text-indigo-600 text-white",
  outline: "border border-blue-500 text-gray-800",
};

export const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  icon,
  position = "top-right",
  theme = "outline",
}) => {
  return (
    <div
      className={clsx(
        "shadow-md rounded-xl px-4 py-3 items-center min-w-[120px] text-center bg-white flex flex-row gap-2",
        positionClasses[position],
        themeClasses[theme],
      )}
    >
      <div className="text-2xl">{icon}</div>
      <div className="flex flex-col items-start max-w-24 justify-start">
        <p className="text-lg font-semibold">{value}</p>
        <p className="text-xs opacity-80 text-start line-clamp-3">{label}</p>
      </div>
    </div>
  );
};
